import api from "@/lib/api";

let cached = null;

export function fetchNavData() {
  if (!cached) {
    cached = api.get("/navigation/mega-menu").then((r) => r.data).catch(() => null);
  }
  return cached;
}
